import Input from '@/common/components/Input';
import { useTranslationContext } from '@/common/hooks/useTranslationContext';
import React from 'react';
import { mapInputsToAddressBG } from '../inputsSK/mapInputsToAddressBG';

const InputsBG = ({ addressFormInputs, handleChangeInputValue }) => {
	const { translation } = useTranslationContext();

	return (
		<>
			<Input
				margin='6px'
				name={translation.postalCode}
				width={120}
				inputWidth={260}
				value={addressFormInputs.postalCode}
				requiredSign
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('postalCode', e)}
			/>
			<Input
				margin='6px'
				name={translation.city}
				width={120}
				inputWidth={260}
				value={addressFormInputs.city}
				requiredSign
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('city', e)}
			/>
			<Input
				margin='6px'
				name={translation.quarter}
				width={120}
				inputWidth={260}
				value={addressFormInputs.quarter}
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('quarter', e)}
			/>
			<Input
				margin='6px'
				name={translation.street}
				width={120}
				inputWidth={260}
				value={addressFormInputs.street}
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('street', e)}
			/>
			<Input
				margin='6px'
				name={translation.businessOrComplexName}
				width={120}
				inputWidth={260}
				value={addressFormInputs.businessOrComplexName}
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('businessOrComplexName', e)}
			/>
			<Input
				margin='6px'
				name={translation.streetNumber}
				width={120}
				inputWidth={260}
				value={addressFormInputs.streetNumber}
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('streetNumber', e)}
			/>
			<Input
				margin='6px'
				name={translation.building}
				width={120}
				inputWidth={260}
				value={addressFormInputs.building}
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('building', e)}
				requiredSign={false}
			/>
			<Input
				margin='6px'
				name={translation.entrance}
				width={120}
				inputWidth={260}
				value={addressFormInputs.entrance}
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('entrance', e)}
			/>
			<Input
				margin='6px'
				name={translation.staircase}
				width={120}
				inputWidth={260}
				value={addressFormInputs.staircase}
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('staircase', e)}
			/>
			<Input
				margin='6px'
				name={translation.floor}
				width={120}
				inputWidth={260}
				value={addressFormInputs.floor}
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('floor', e)}
			/>
			<Input
				margin='6px'
				name={translation.apartment}
				width={120}
				inputWidth={260}
				value={addressFormInputs.apartment}
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('apartment', e)}
			/>
			<Input
				margin='6px'
				name={translation.phone_number_for_courier}
				width={120}
				inputWidth={260}
				value={addressFormInputs.phoneForCourier}
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('phoneForCourier', e)}
			/>
			<Input
				margin='6px'
				name={translation.courierInfo}
				width={120}
				inputWidth={260}
				value={addressFormInputs.additionalInfo}
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('additionalInfo', e)}
			/>
			<div
				style={{
					marginTop: '18px',
				}}
			>
				<span
					style={{
						fontWeight: 'bold',
						marginRight: '12px',
					}}
				>
					{translation.address}:
				</span>
				<span>{mapInputsToAddressBG(addressFormInputs)}</span>
			</div>
		</>
	);
};

export default InputsBG;
